// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LineItemsList-module_line_items_table_XtpV8 {
  min-width: 400px;
  cursor: default;
}

.LineItemsList-module_line_items_table_compact_CqgPM {
}

.LineItemsList-module_line_items_table_edit_mode_aiFgR {
}

.LineItemsList-module_table_header_cell_nO_lk {
  white-space: nowrap;
}

.LineItemsList-module_money_cell_YVLpC {
}

.LineItemsList-module_shipping_row_ls8Ym td {
  padding-top: 10px;
}

.LineItemsList-module_shipping_cell_Tt0s6 {
  vertical-align: bottom !important;
  padding-bottom: 10px;
  text-align: right;
  font-weight: 500;
}

.LineItemsList-module_order_total_label_uPi4f {
  vertical-align: top !important;
  text-align: right;
  font-weight: 600;
}

.LineItemsList-module_table_total_cell_vODsT {
  padding-left: 6px;
}

.LineItemsList-module_received_button_AXjaR {
  background-color: var(--status_received) !important;
  text-align: center !important;
  font-size: small;
}

.LineItemsList-module_received_button_AXjaR span {
  color: white !important;
}

.LineItemsList-module_description_box_s9kpZ {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.LineItemsList-module_comment_label_hnWfh {
  color: var(--text-color);
}

.LineItemsList-module_comment_popover_nCRVd {
  margin-left: auto;
}

.LineItemsList-module_comment_table_div_hbKjU {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  gap: 4px;
  font-style: italic;
}

.LineItemsList-module_comment_icon_cBeGQ {
  color: var(--primary-bos-color);
  margin-left: auto;
  cursor: pointer;
}

.LineItemsList-module_light_border_bottom_jBC1x {
  border-bottom: 1px solid var(--bp-light-gray1);
}

.LineItemsList-module_light_background_xADIB {
  background-color: var(--bp-light-gray5);
}

.LineItemsList-module_received_info_box_HCTNK {
  padding: 8px;
}

.LineItemsList-module_dummy_checkboxes_cdX7A {
  margin-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/LineItems/LineItemsList.module.css"],"names":[],"mappings":"AAAA;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;AAGA;;AAEA;AAEA;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EAEE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".line_items_table {\n  composes: editable_table from 'Styles/styles.module.css';\n  min-width: 400px;\n  cursor: default;\n}\n\n.line_items_table_compact {\n  composes: line_items_table;\n  composes: editable_table_compact from 'Styles/styles.module.css';\n}\n\n.line_items_table_edit_mode {\n  composes: editable_table_edit_mode from 'Styles/styles.module.css';\n}\n\n.table_header_cell {\n  composes: table_header_cell from 'Styles/styles.module.css';\n  white-space: nowrap;\n}\n\n.money_cell {\n  composes: money_cell from 'Styles/styles.module.css';\n}\n\n.shipping_row td {\n  padding-top: 10px;\n}\n\n.shipping_cell {\n  vertical-align: bottom !important;\n  padding-bottom: 10px;\n  text-align: right;\n  font-weight: 500;\n}\n\n.order_total_label {\n  vertical-align: top !important;\n  text-align: right;\n  font-weight: 600;\n}\n\n.table_total_cell {\n  composes: table_total_cell from 'Styles/styles.module.css';\n  padding-left: 6px;\n}\n\n.received_button {\n  background-color: var(--status_received) !important;\n  text-align: center !important;\n  font-size: small;\n}\n\n.received_button span {\n  color: white !important;\n}\n\n.description_box {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.comment_label {\n  composes: bos_label from 'Styles/styles.module.css';\n  color: var(--text-color);\n}\n\n.comment_popover {\n  margin-left: auto;\n}\n\n.comment_table_div {\n  composes: secondary_color from 'Styles/colors.module.css';\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  gap: 4px;\n  font-style: italic;\n}\n\n.comment_icon {\n  color: var(--primary-bos-color);\n  margin-left: auto;\n  cursor: pointer;\n}\n\n.light_border_bottom {\n  border-bottom: 1px solid var(--bp-light-gray1);\n}\n\n.light_background {\n  background-color: var(--bp-light-gray5);\n}\n\n.received_info_box {\n  composes: row_selected_background from 'Styles/colors.module.css';\n  padding: 8px;\n}\n\n.dummy_checkboxes {\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"line_items_table": `LineItemsList-module_line_items_table_XtpV8 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table"]}`,
	"line_items_table_compact": `LineItemsList-module_line_items_table_compact_CqgPM LineItemsList-module_line_items_table_XtpV8 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table_compact"]}`,
	"line_items_table_edit_mode": `LineItemsList-module_line_items_table_edit_mode_aiFgR ${___CSS_LOADER_ICSS_IMPORT_0___.locals["editable_table_edit_mode"]}`,
	"table_header_cell": `LineItemsList-module_table_header_cell_nO_lk ${___CSS_LOADER_ICSS_IMPORT_0___.locals["table_header_cell"]}`,
	"money_cell": `LineItemsList-module_money_cell_YVLpC ${___CSS_LOADER_ICSS_IMPORT_0___.locals["money_cell"]}`,
	"shipping_row": `LineItemsList-module_shipping_row_ls8Ym`,
	"shipping_cell": `LineItemsList-module_shipping_cell_Tt0s6`,
	"order_total_label": `LineItemsList-module_order_total_label_uPi4f`,
	"table_total_cell": `LineItemsList-module_table_total_cell_vODsT ${___CSS_LOADER_ICSS_IMPORT_0___.locals["table_total_cell"]}`,
	"received_button": `LineItemsList-module_received_button_AXjaR`,
	"description_box": `LineItemsList-module_description_box_s9kpZ`,
	"comment_label": `LineItemsList-module_comment_label_hnWfh ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_label"]}`,
	"comment_popover": `LineItemsList-module_comment_popover_nCRVd`,
	"comment_table_div": `LineItemsList-module_comment_table_div_hbKjU ${___CSS_LOADER_ICSS_IMPORT_1___.locals["secondary_color"]}`,
	"comment_icon": `LineItemsList-module_comment_icon_cBeGQ`,
	"light_border_bottom": `LineItemsList-module_light_border_bottom_jBC1x`,
	"light_background": `LineItemsList-module_light_background_xADIB`,
	"received_info_box": `LineItemsList-module_received_info_box_HCTNK ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row_selected_background"]}`,
	"dummy_checkboxes": `LineItemsList-module_dummy_checkboxes_cdX7A`
};
export default ___CSS_LOADER_EXPORT___;
